module.exports = __webpack_public_path__ + "img/interviewed.21109599.svg";